function elementInViewport(myElement) {
    var myElementHeight = myElement.offsetHeight;
    var myElementWidth = myElement.offsetWidth;
    var bounding = myElement.getBoundingClientRect();
    if (bounding.top >= -myElementHeight &&
        bounding.left >= -myElementWidth &&
        bounding.right <=
            (window.innerWidth || document.documentElement.clientWidth) +
                myElementWidth &&
        bounding.bottom <=
            (window.innerHeight || document.documentElement.clientHeight) +
                myElementHeight) {
        return true;
    }
    else {
        return false;
    }
}
export default elementInViewport;
